// extracted by mini-css-extract-plugin
export default {"cls1":"zpAh0xQJXMPsFUk5S09b","cls2":"VrFQX2kjlxFeyhhtockw zpAh0xQJXMPsFUk5S09b"};